import APIClient from './index';
import _ from 'lodash';

export const fetchUsers = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Users?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const fetchUserByEmail = data => {
  return new Promise(resolve => {
    APIClient.post('Users/find_by_email', data)
      .then(response => resolve({ user: response.data }))
      .catch(err => resolve({ user: null, error: err?.data?.error }));
  });
};

export const fetchUserThroughUsername = (username, params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/Users/username/${username}${_.isEmpty(params) ? '' : '?'}${new URLSearchParams(params).toString()}`)
      .then(response => {
        const { user } = response.data;
        resolve({ user });
      })
      .catch(err => reject(false));
  });
};

// The app's lightweight deep-link resolver — returns just { id, name, username, image, trustedByCount },
// unlike fetchUserThroughUsername which returns the full shop payload.
export const fetchUserFromUsername = username => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/Users/from_username/${encodeURIComponent(username)}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateUser = (user, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`Users/${user.id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Persist per-user admin UI flags (used for nav pinned/recent shortcuts) via the shared UserSettings endpoint.
export const updateAdminNavPreferences = (User_id, flags) => {
  return new Promise((resolve, reject) => {
    APIClient.put('UserSettings/ui', { User_id, flags })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const udpateUserAddress = (User_id, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UserAddresses`, { User_id, ...updates })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Platform-admin action (server enforces the ALL scope): clears the user's Cognito software-token MFA.
export const disableUserMfa = User_id => {
  return new Promise((resolve, reject) => {
    APIClient.post('Auth/mfa/admin_disable', { User_id })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const fetchUser = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Users/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const fetchUserCounts = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('Users/counts')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
